import Core        from '@/core/Core';
import BaseEntity  from '@/core/misc/BaseEntity';
import Title_ru_RU from '@/core/misc/decorators/Title_ru_RU';
import TYPES       from '@/core/services/Changelogs/types';
import Title_ru_RU_Class from "@/core/misc/decorators/Title_ru_RU_Class";
import TradeMark   from '@/domains/TradeMarks/TradeMark';

@Title_ru_RU_Class('Производитель')
class Manufacturer extends BaseEntity {

  static Events = {
    Created: 'manufacturer:created',
    Updated: 'manufacturer:updated',
    Deleted: 'manufacturer:deleted',
  } as const;

  @Title_ru_RU('Название', TYPES.STRING)
  public name: string;

  @Title_ru_RU('Торговые марки', TYPES.STRING)
  public tradeMarks: TradeMark[] = [];

  static fromServer(data: any, result = new Manufacturer()): Manufacturer {
    super.fromServer(data, result);

    result.tradeMarks = Core.utils.hydrateArray(data.tradeMarks, TradeMark.fromServer);

    return result;
  }

  toString(): string {
    return this.name;
  }
}

export default Manufacturer;
